import React, { useState, useEffect } from 'react'

const CountdownTimer = ({ dueDate }) => {
  const [countdown, setCountdown] = useState(null)
  const [intervalId, setIntervalId] = useState(null)
  useEffect(() => {
    const currDate = new Date()
    try {
      const date = new Date(dueDate)
      if (date.getTime() > currDate.getTime()) {
        let timeout = (date.getTime() - currDate.getTime()) / (1000 * 60)
        timeout = Math.floor(timeout)
        setCountdown(timeout)
        const id = setInterval(() => {
          if (countdown > 0) {
            const newTime = countdown - 1
            setCountdown(newTime)
          } else {
            clearInterval(intervalId)
          }
        }, 60000)
        setIntervalId(id)
      }
    } catch (e) {
      console.error(e)
    }
  }, [])
  return (
    <If condition={countdown && countdown > 0}>
      <span className="color-8a fs-13">{countdown} mins</span>
    </If>
  )
}
export default CountdownTimer
